var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"ui-logo",class:[{ black: _vm.black }, { small: _vm.small }],attrs:{"href":"/"}},[_vm._v(" Время сна ")])}
var staticRenderFns = []

export { render, staticRenderFns }